<div class="modal-header bg-dark text-white">
    <h5 class="modal-title mb-0 fw-bold">Referral List</h5>
    <button type="button" class="btn-close btn-close-white" (click)="closeEvent.emit(true)"></button>
</div>
<div class="modal-body p-0">
    <div *ngIf="is_loading_function" class="text-center py-5">
        <div class="spinner-border spinner-border-sm text-primary"></div>
        <p class="mt-2 text-muted small">Loading referrals...</p>
    </div>
    <div class="table-container" *ngIf="!is_loading_function" style="max-height: 60vh; overflow-y: auto;">
        <table class="table table-striped mb-0" *ngIf="referrals.length > 0">
            <thead class="bg-dark text-light">
                <tr style="position: sticky; top: 0;">
                    <th class="table-header" style="width: 40px">#</th>
                    <th class="table-header">Code</th>
                    <th class="table-header">Name</th>
                    <th class="table-header">Fullname</th>
                    <th class="table-header">Mobile</th>
                    <th class="table-header text-center">Agent %</th>
                    <th class="table-header text-center">Referrals</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let referral of referrals; let i = index">
                    <td>{{i + 1}}</td>
                    <td>{{referral.code || '-'}}</td>
                    <td>{{referral.name}}</td>
                    <td class="text-muted">{{referral.fullname || '-'}}</td>
                    <td>{{referral.mobile}}</td>
                    <td class="text-center">
                        <span *ngIf="referral.is_agent == 1 && referral.agent_rate" class="badge bg-info">{{referral.agent_rate | number:'1.0-3'}}%</span>
                        <span *ngIf="!referral.is_agent || referral.is_agent != 1" class="text-muted">-</span>
                    </td>
                    <td class="text-center">{{referral.no_of_referral || 0}}</td>
                </tr>
            </tbody>
        </table>
        <div *ngIf="referrals.length == 0" class="text-center py-5 text-muted">
            No referrals found
        </div>
    </div>
</div>
<div class="modal-footer d-flex justify-content-between align-items-center" *ngIf="!is_loading_function && referrals.length > 0">
    <div class="text-muted small">Total: {{referrals.length}} referral(s)</div>
    <button class="btn btn-sm btn-secondary" (click)="closeEvent.emit(true)">Close</button>
</div>
